export enum StateType {
  UPLOAD,
  TABLE,
  ERROR,
  OFFLINE,
}
